import { render, staticRenderFns } from "./NewsItem.vue?vue&type=template&id=0997d45d&scoped=true&"
import script from "./NewsItem.vue?vue&type=script&lang=js&"
export * from "./NewsItem.vue?vue&type=script&lang=js&"
import style0 from "./NewsItem.vue?vue&type=style&index=0&id=0997d45d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0997d45d",
  null
  
)

export default component.exports